import Customize from "./Customize";
import MotionDetection from "./MotionDetection";
import NoiseDetection from "./NoiseDetection";
import VideoQuality from "./VideoQuality";
import Settings from "./Settings";
import ReplayDuration from "./ReplayDuration";
import Watermark from "./Watermark";
import DetectionZones from "./DetectionZones";
import DetectionZonesHelp from "./DetectionZonesHelp";

const steps = [
  { id: "settings", Component: Settings },
  { id: "customize", Component: Customize },
  { id: "noise-detection", Component: NoiseDetection },
  { id: "motion-detection", Component: MotionDetection },
  { id: "video-quality", Component: VideoQuality },
  { id: "replay-duration", Component: ReplayDuration },
  { id: "watermark", Component: Watermark },
  { id: "detection-zones", Component: DetectionZones },
  { id: "detection-zones-help", Component: DetectionZonesHelp }
] as {
  id: string;
  Component: (props: FlowProviding & Keyable) => JSX.Element;
}[];

export default steps;
